export enum DirectIds {
  DI1_JOHN = "M1GfRY4g",
  DI2_CONNOR = "8B5NUb5M",
  DI3_MATTHEW = "bhUHVpDN",
  DI4_ALL = "EDsKLwZA",
  DI5_NEW_USER_NOTIFY = "XMhUobTv",
  DI6_NONE = "aeaeaeae",
}
